'use client'

import { Text, Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { PrivacyCardModel } from '@marketplace-web/user-agreements/privacy-center-data'

const PrivacyControlCard = ({
  imageSrc,
  title,
  description,
  link,
  link_a11y,
}: PrivacyCardModel) => {
  const translate = useTranslate()

  return (
    <article className="privacy-center__control-card">
      <div>
        <div className="privacy-center__control-card-image">
          <Image src={imageSrc} loading="lazy" />
        </div>
        <h3 className="privacy-center__control-card-title">{translate(title)}</h3>
        <div className="privacy-center__control-card-description">
          <Text as="p" text={translate(description)} html />
        </div>
      </div>
      <div className="privacy-center__control-card-link">
        {link && (
          <Text
            as="div"
            text={translate(link)}
            html
            aria={{ 'aria-label': link_a11y ? translate(link_a11y) : '' }}
          />
        )}
      </div>
    </article>
  )
}

export default PrivacyControlCard
